<template>
  <Sidebar v-model:visible="visible" position="right" @hide="onHide">
    <div v-if="deviceImport" class="flex flex-col space-y-8">
      <div>
        <div class="flex items-center space-x-3">
          <h3 class="text-xl font-bold text-gray-900 sm:text-2xl">{{ deviceImport.import_type?.name }}</h3>

          <FlatBadge :color="statuses[deviceImport.status]" :value="deviceImport.status"/>
        </div>
      </div>

      <div>
        <DescriptionList :title="$t('slide_overs.device_import_details_slide_over.information')" class="mt-2">
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.initiated_by')"
                               :details="deviceImport.user?.name"/>
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.initiated_at')"
                               :details="deviceImport.request_date ? $dateService(deviceImport.request_date).format('MMM DD, YYYY HH:mm:ss') : undefined"/>
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.completed_at')"
                               :details="deviceImport.completed_date ? $dateService(deviceImport.completed_date).format('MMM DD, YYYY HH:mm:ss') : undefined"/>
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.time_taken')"
                               :details="(deviceImport.request_date && deviceImport.completed_date) ? getDifferenceBetweenDates(deviceImport.request_date, deviceImport.completed_date) : undefined"/>
        </DescriptionList>
      </div>

      <div>
        <DescriptionList :title="$t('slide_overs.device_import_details_slide_over.import_details')" class="mt-2">
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.name')"
                               :details="deviceImport.name"/>
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.status')"
                               :details="deviceImport.status"/>
          <DescriptionListItem v-if="deviceImport.status == 'FAILED'"
                               :term="$t('slide_overs.device_import_details_slide_over.errors')"
                               :details="deviceImport.error ?? undefined"/>
          <DescriptionListItem :truncated="false" :term="$t('slide_overs.device_import_details_slide_over.payload')"
                               :details="deviceImport.payload ?? undefined"/>
        </DescriptionList>
      </div>

      <div>
        <DescriptionList :title="$t('slide_overs.device_import_details_slide_over.file')" class="mt-2">
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.file_path')"
                               :details="deviceImport.path"/>
          <DescriptionListItem :term="$t('slide_overs.device_import_details_slide_over.file_path')"
                               :details="useFilesize(deviceImport.size_bytes)"/>
        </DescriptionList>
      </div>
      <Button :label="$t('slide_overs.device_import_details_slide_over.download_import_file')"
              @click="downloadImportFile()"/>
    </div>
  </Sidebar>
</template>

<script>
import {mapStores} from "pinia";
import {useDeviceImportsStore} from "@/stores/deviceImports.js";
import FlatBadge from "@/Components/Badges/FlatBadge.vue";
import {useFilesize} from "@/Composables/Filesize.js";
import DescriptionList from "@/Components/DescriptionList.vue";
import DescriptionListItem from "@/Components/DescriptionListItem.vue";
import ValueChange from "@/Components/ValueChange.vue";
import dayjs from "dayjs";
import {useDownloadLink} from "@/Composables/DownloadLink.js";

export default {
  name: "DeviceImportSlideOver",
  components: {ValueChange, DescriptionListItem, DescriptionList, FlatBadge},
  data() {
    return {
      visible: false,
      params: {
        include: [
          'importType',
          'user',
        ],
        fields: {
          imports: [
            'id',
            'import_type_id',
            'name',
            'path',
            'size_bytes',
            'user_id',
            'status',
            'error',
            'payload',
            'request_date',
            'initiated_date',
            'completed_date',
          ]
        },
      },
      deviceImport: undefined,
      statuses: {
        PENDING: 'gray',
        IN_PROGRESS: 'yellow',
        COMPLETE: 'green',
        FAILED: 'red',
      },
    }
  },
  computed: {
    ...mapStores(useDeviceImportsStore),
    title() {
      return this.deviceImport?.id
          ? this.$t('slide_overs.device_import_details_slide_over.download_log_x', {id: this.deviceImport?.id})
          : this.$t('slide_overs.device_import_details_slide_over.device_log');
    },
  },
  methods: {
    useFilesize,
    async showDeviceImportDetails(deviceImport) {
      if (!deviceImport)
        return;

      this.deviceImport = deviceImport;
      this.visible = true;
      this.deviceImport = await this.deviceImportsStore.showDeviceImport(deviceImport.id, this.params);
    },
    onHide() {
      this.deviceImport = undefined;
    },
    getDifferenceBetweenDates(end, start) {
      start = dayjs(start)
      end = dayjs(end)
      return start.diff(end, 'seconds') + ' seconds'
    },
    async downloadImportFile() {
      if (this.deviceImport.id) {
        try {
          const response = await this.deviceImportsStore.showDeviceImport(this.deviceImport.id, {download: 1});
          useDownloadLink(response.url);
        } catch (error) {
          console.log('Error downloading import file', error);
        }
      }
    },
  },
}
</script>